<template>
  <v-card>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex v-for="(item, index) in items" :key="index" sm4 md3 xs12>
          <v-menu offset-y v-if="item.markets && Object.keys(item.markets).length > 1">
            <v-btn slot="activator" flat color="primary">
              <v-icon large>{{ item.icon }}</v-icon> {{ item.text }}
            </v-btn>
            <v-list>
              <v-list-tile
                v-for="([marketName, marketId], index) in clientMarketsSorted"
                :key="index"
                @click="goToMarketNode(marketId, item.to)"
              >
                <v-list-tile-title>{{ marketName }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-menu offset-y v-else-if="item.subItems">
            <v-btn slot="activator" flat color="primary">
              <v-icon large>{{ item.icon }}</v-icon> {{ item.text }}
            </v-btn>
            <v-list>
              <v-list-tile
                v-for="(subItem, index) in item.subItems"
                :key="index"
                :to="subItem.to"
                @click="subItem.click && subItem.click($event)"
                :disabled="!subItem.to && !subItem.click"
              >
                <v-list-tile-title>
                  <v-icon>{{ subItem.icon }}</v-icon>
                  {{ subItem.text }}</v-list-tile-title
                >
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn
            v-else
            flat
            color="primary"
            :to="item.to"
            @click="item.click && item.click($event)"
          >
            <v-icon large>{{ item.icon }}</v-icon> {{ item.text }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import {mapGetters} from 'vuex'
import {getItemsFromFolder, getItemsFromFolderAndMarket} from '../helpers/menu-helpers'
import cookie from '../helpers/cookie'
import markets from '../enums/market'

export default {
  methods: {
    async goToMarketNode(marketId, to) {
      await this.$store.dispatch('app/setMenuMarket', {marketId})
      this.$router.push(to)
    },
    getFolderItem(items, folder, market) {
      const nodes = getItemsFromFolderAndMarket(items, folder, market)
      return nodes.map(item => {
        const to = item.to
        return {
          to: '',
          click: () => {
            this.goToMarketNode(markets[market], to)
          },
          ...item,
        }
      })
    },
  },
  computed: {
    ...mapGetters({currentUsername: 'authentication/currentUsername'}),
    ...mapGetters({role: 'authentication/currentRole'}),
    ...mapGetters({itemsForRole: 'app/pathsForCurrentRole'}),
    ...mapGetters({token: 'authentication/tokenString'}),
    ...mapGetters({userClientMarkets: 'authentication/userClientMarkets'}),
    clientMarkets() {
      let clientMarkets = this.userClientMarkets.reduce((acc, item) => {
        acc[item.market] = item.marketId
        return acc
      }, {})

      return clientMarkets
    },
    clientMarketsSorted() {
      const entries = Object.entries(this.clientMarkets)
      const baseIndex = entries.findIndex(([market]) => market === 'Base')
      if (baseIndex >= 0) {
        entries.push(entries.splice(baseIndex, 1)[0])
      }

      return entries
    },
    items() {
      const itemsForRole = this.itemsForRole
      const dashboardItems = [
        {
          to: '/list/otc-trade',
        },
        {
          to: '/list/otc-histo',
        },
        {
          to: '/list/future',
        },
        {
          to: '/list/order',
        },
        {
          to: '/report/base-dashboard',
        },
        {icon: 'autorenew', text: 'Cashflow', to: '/list/cashflow'},
        {
          to: '/month end/bon-coup',
        },
        {
          icon: 'fas fa-money-bill-wave',
          text: 'FX Reports',
          subItems: this.getFolderItem(itemsForRole, '/report', 'FX'),
          market: 'FX',
        },
        {
          icon: 'fas fa-seedling',
          text: 'AG Reports',
          subItems: this.getFolderItem(itemsForRole, '/report', 'AG'),
          market: 'AG',
        },
        {
          icon: 'fas fa-burn',
          text: 'EN Reports',
          subItems: this.getFolderItem(itemsForRole, '/report', 'Energy'),
          market: 'Energy',
        },
        {to: '/report/exposure'},
        {
          text: 'Configuration',
          icon: 'build',
          subItems: getItemsFromFolder(itemsForRole, '/config'),
        },
        {
          to: '/report/base-marketdata',
        },
        {to: '/marketdata/currency'},
        {to: '/process/manager'},
        {
          to: '/list/Rates',
        },
        {to: '/client/users'},
      ]

      if (this.role == 'SuperAdmin') {
        dashboardItems.push({
          icon: 'security',
          text: 'Security',
          subItems: getItemsFromFolder(itemsForRole, '/security'),
        })
      }

      const itemsByPath = itemsForRole.reduce((acc, item) => {
        acc[item.path] = item
        return acc
      }, {})

      if (this.currentUsername == 'dev@visionap.com') {
        dashboardItems.push({
          text: 'Dev Tools',
          icon: 'developer_board',
          subItems: [
            {
              text: 'Error Log',
              icon: 'bug_report',
              click: () => {
                cookie.setCookie('token', this.token, 10)
                window.open('/elmah')
              },
            },
            {
              text: 'Process Manager Jobs',
              icon: 'fas fa-tasks',
              click: () => {
                cookie.setCookie('token', this.token, 10)
                window.open('/hangfire')
              },
            },
          ],
        })
      }

      let clientMarkets = Object.keys(this.clientMarkets)

      return dashboardItems
        .filter(m => m.market == null || clientMarkets.includes(m.market))
        .map(item => {
          if (item.to) {
            const permission = itemsByPath[item.to]
            if (permission) {
              return {...item, ...permission.meta, text: permission.text}
            } else {
              return null
            }
          } else if (item.subItems || item.click) {
            return item
          }
        })
        .filter(item => item != null)
    },
  },
}
</script>
